import update from 'immutability-helper';
import { createReducer } from '@api/createRequestStore';
import { combineReducers } from 'redux';
import * as types from './types';

const initialState = {
  isWarningModalVisible: false,
  action: {
    selectedConfig: null,
    actionType: null,
  },
};

const switchMap = {};

switchMap[types.CHANGE_WARNING_CONTAINER_VISIBILITY] = (state, action) => update(state, {
  isWarningModalVisible: {
    $set: action.visible,
  },
});

switchMap[types.UPDATE_TABLE_ACTION] = (state, action) => update(state, {
  action: {
    $set: action.action,
  },
});

const coreReducer = (state = initialState, action) => (switchMap[action.type]
  ? switchMap[action.type](state, action) : state);

export default combineReducers({
  core: coreReducer,
  requests: createReducer(types.SCOPE),
});
